import type { BalanceResponse } from '../../repositories/payment-repo/schemas/balance.zod';
import { PriceVO } from '../price';

export class Balance {
  private balance: PriceVO;

  private overdueBalance: PriceVO | null;

  constructor(apiResponse: BalanceResponse) {
    this.balance = new PriceVO(apiResponse);
    // If the balance is negative calculate the positive overdue amount (to process the overdue payment)
    this.overdueBalance = this.balance.priceAmount < 0 ? new PriceVO(Math.abs(this.balance.priceAmount)) : null;
  }

  public getBalance() {
    return this.balance;
  }

  /**
   * Returns the positive due amount if the balance is negative,
   * otherwise returns null.
   */
  public getOverdueBalance() {
    return this.overdueBalance;
  }

  /**
   * Indicates whether the balance is overdue (i.e. negative).
   */
  public hasOverdue() {
    return this.balance.priceAmount < 0;
  }

  /**
   * Indicates whether the balance is positive (i.e. zero or above).
   */
  public isOverdueFree() {
    return this.balance.priceAmount >= 0;
  }
}
